<div class="cell auto grid-y align-center align-middle" *ngIf="decision">
    <h1 class="cell shrink _primary areaTitle"[i18nKey]="'decisions.area.title'"></h1>

    <kiwi-animator-select-team></kiwi-animator-select-team>

    <div class="cell shrink areaMap">
        <div class="areaMap-img"></div>

        <div class="townImg _bad" (click)="selectArea(decision.workingClassArea)"
             [class._active]="selectedArea == decision.workingClassArea"></div>

        <div class="townImg _medium" (click)="selectArea(decision.averageArea)"
             [class._active]="selectedArea == decision.averageArea"></div>

        <div class="townImg _good" (click)="selectArea(decision.wealthyArea)"
             [class._active]="selectedArea == decision.wealthyArea"></div>
    </div>
</div>

<kiwi-area-portrait class="cell shrink areaDescription"
                   [class._showDetail]="decision && selectedArea"
                   [area]="selectedArea"
                   [areDecisionsReadonly]="decisionsReadonly || period !== '0101'"
                   [areaPortrait]="selectedAreaPortrait"
                   (chosenArea)="onSave($event)"
                    *ngIf="displayAreaPortrait"></kiwi-area-portrait>


